export const IntegrationsRoute = 'integrations';

export const SOURCE_ENTITY_TYPE = 'ai_assistant_app';

export enum SourceType {
  DOCUMENT = 'document',
  URL = 'url',
  PROJECT_TEAM = 'project_team',
  SHAREPOINT = 'sharepoint',
  GOOGLEDRIVE = 'googledrive',
}

export enum SourceTrainingStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in progress',
  SUCCESS = 'success',
  FAIL = 'fail',
}

export enum AIChatConversationInterval {
  THIRTY_DAYS = '30 days',
  SEVEN_DAYS = '7 days',
  ALL = 'all',
}

export enum AIChatConversationType {
  ALL = 'All Conversations',
  UNABLE_TO_ANSWER = 'Unable to answer',
}

export enum AIChatConversationPlatform {
  ALL = 'all origins',
  CHATBOT = 'chatbot',
  SLACK = 'slack',
  EMAIL = 'email',
}
